// extracted by mini-css-extract-plugin
module.exports = {"FrontInfoBox":"FrontInfoBox_FrontInfoBox__10MK_"};